import { useState } from 'react';
import { SnappyIntegrationConfig } from 'settings/Settings.types';

import {
  isSnappyIntegrationActive,
  isInitializingSnappyIntegration
} from 'settings/utils/snappyIntegration';
import { useSnappy } from 'settings/hooks/useSnappy';

import { ToggleOptions } from '../ToggleOptions';
import { SnappyApiDialog } from './SnappyApiDialog';
import { DisconnectSnappyConfirmationDialog } from './DisconnectSnappyConfirmationDialog';

export function RewardsSnappyIntegration({
  value,
  onChange = () => {},
}: RewardsSnappyIntegrationProps) {
  const { connect, disconnect } = useSnappy();
  const [isDisconnecting, setDisconnecting] = useState(false);
  const integrationOptions = [
    { id: 'enable', text: 'Yes', value: true },
    { id: 'disable', text: 'No', value: false },
  ];

  const isActivating = isInitializingSnappyIntegration(value);
  const integrationActiveStatus = isSnappyIntegrationActive(value);

  const handleChange = (active: boolean) => {
    if (integrationActiveStatus && !active) {
      setDisconnecting(true);
      return;
    }

    onChange({ active, apiKey: null });
  };

  const closeDisconnectingDialog = () => setDisconnecting(false);

  return (
    <>
      <ToggleOptions
        options={integrationOptions}
        value={integrationActiveStatus}
        onChange={handleChange}
        title="Connected to a Gifting Platform"
        description="Agent Connect teamed up with Snappy to offer you more ways to reward your teams. When connected with Snappy, reward fulfillment is automated to save you time & money."
      />

      <SnappyApiDialog
        isOpen={isActivating}
        onDismiss={() => onChange({ active: false, apiKey: null })}
        onAccept={(apiKey: string) => {
          connect(apiKey).then(() => onChange({ active: true, apiKey }));
        }}
      />

      <DisconnectSnappyConfirmationDialog
        isOpen={isDisconnecting}
        onDismiss={closeDisconnectingDialog}
        onAccept={() => {
          disconnect().then(() => onChange({ active: false, apiKey: null }));
          closeDisconnectingDialog();
        }}
      />
    </>
  );
}

interface RewardsSnappyIntegrationProps {
  value: SnappyIntegrationConfig;
  onChange?: (newConfig: SnappyIntegrationConfig) => void;
}
